import { useFormik } from 'formik';
import React from 'react';
import { useEffect } from 'react';
import { Button, Form, Modal, Col, Alert } from 'react-bootstrap';
import { useImmer } from 'use-immer';
import * as Yup from "yup";
import FormControls, { ConditionalRender } from '../formControls';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrashAlt } from '@fortawesome/free-solid-svg-icons';
import { MessageService, UserService } from '../../services';

const initValues = {
    "sentFromUserId": undefined,
    "accountId": undefined,
    "sentFromUser": undefined,
    "subject": '',
    "message": '',
    "attachments": [],
    "replyToMessage": ''
}

const CreateMessageReplyModal = (props) => {
    const [newMessage, setNewMessage] = useImmer({})
    const [contacts, setContacts] = useImmer([]);
    const [serviceCallError, setServiceCallError] = useImmer(null);

    useEffect(() => {
        //getContacts();
    }, [])

    const getContacts = async () => {
        let contacts = [];
        var userService = new UserService();
        var callResult = await userService.getContactsForUser();
        if (callResult.result) {

            const results = callResult.model;
            contacts = results.accounts.map(grp => ({
                label: grp.name, id: grp.id, options: grp.contacts.map(cntc => ({
                    label: cntc.fullName, value: cntc.id
                }))
            }))
        } else {
            setServiceCallError({ title: "Error attaching files.", text: callResult.message })
            return false; // failed
        }
        setContacts(contacts);
    }

    useEffect(() => {
        // set initial values to newMessage
        let initMessage = initValues;
        Object.assign(initMessage, props.model);
        setNewMessage(initMessage)
    }, [props.model])

    const messageValidationSchema = {
        message: Yup.string().required('Message is required.')
            .min(2, 'Message must contain more than one characters.')
            .max(4000, 'Message must have less than 4000 characters.'),
        
    };

    const saveMessage = async (values) => {
        const service = new MessageService();
        const callResult = await service.createMessage(values);
        if (callResult.result) {
            const model = callResult.model;
            let attachmentError = false;
            if (formHandler.values.attachments?.length > 0) {
                var attachResult = await attachFiles(values.attachments, model.id);
                attachmentError = !attachResult;
            }
            if (!attachmentError) {
                props.onSaveCallback();
                props.closeModal();
            }
        } else {
            setServiceCallError({ title: "Error attaching files.", text: callResult.message })
            return false; // failed
        }
    }

    const attachFiles = async (files, messageId) => {
        const formData = new FormData();
        for (let i = 0; i < files.length; i++) {
            formData.append(`files[${i}]`, files[i], files[i].name); //{ "file": files[i], "fileName": files[i].name }
        }

        formData.append(
            "messageId", messageId
        );

        const service = new MessageService();
        const callResult = await service.attachFiles(formData, messageId);
        if (callResult.result) {
            return true;
        } else {
            setServiceCallError({ title: "Error attaching files.", text: callResult.message })
            return false; // failed
        }
    }

    const formHandler = useFormik({
        initialValues: newMessage,
        validationSchema: Yup.object().shape(messageValidationSchema),
        enableReinitialize: true,
        onSubmit: async (values, { setSubmitting, setErrors, setStatus, resetForm }) => {
            await saveMessage(values);
            setSubmitting(false);
        }
    });

    return (
        <>
            <Modal.Header><div>Creating Reply</div></Modal.Header>
            <Modal.Body>
                <ConditionalRender visible={serviceCallError}>
                    <Alert variant="danger">
                        <Alert.Heading>{serviceCallError?.title}</Alert.Heading>
                        {serviceCallError?.text}
                    </Alert>
                </ConditionalRender>
                <Form.Row>
                    <Form.Group as={Col} lg="12" md="12">
                        <FormControls.Textarea
                            label="Message"
                            name="message"
                            formHandler={formHandler}
                            rows="6" />
                    </Form.Group>
                </Form.Row>
                <Form.Row>
                    <Form.Group as={Col} lg="12" md="12">
                        <FormControls.FileSelector
                            name="attachments"
                            label="Attachments"
                            formHandler={formHandler} />
                    </Form.Group>
                </Form.Row>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="light" onClick={props.closeModal}>Cancel</Button>
                <Button variant="primary" disabled={formHandler.isSubmitting} onClick={() => formHandler.submitForm()}>Save</Button>
            </Modal.Footer>
        </>
    );
};

export default CreateMessageReplyModal;